<div class="dark-mode-container">
  <div (click)="logout()" class="sidebar-button" matTooltip="{{ 'NGX-MESSAGING.logout' | translate }}">
    <mat-icon svgIcon="logout"></mat-icon>
  </div>
</div>
